import type { HttpRequestConfig } from '../lib/utils/httpClient';

export interface ConsultHistoryProps {
  consultId: number;
  sessionId: string;
  createdBy: string;
  createdOn: string;
  status: string;
  modifiedIn: string;
  consultStatus?: ConsultStatus[];
  consultCompleted?: ConsultCompleted[];
  consultCanceled?: ConsultCanceled[];
  consultOnHold?: ConsultOnHold[];
  consultOtherActions?: ConsultOtherActions[];
}

export interface ConsultStatus {
  fromStatus: string;
  toStatus: string;
  modifiedBy: string;
  modifiedOn: string;
  action: string;
  portal: string;
  waitTime: string;
  previousProvider: string;
  updatedColumnName: string;
  onHoldReason?: string;
  onHoldSubReason?: string;
  onHoldOtherReason?: string;
}

export interface ConsultCompleted {
  billable: string;
  diagnosis: string;
  otherDiagnosis: string;
  recommendations: string;
  emCodes: string;
  unitOrDepartment: string;
  completedBy: string;
  completedOn: string;
  action: string;
  portal: string;
  surge: boolean;
  followUp: string;
  opsReasonForCompletion: string;
}

export interface ConsultCanceled {
  cancelReason: string;
  subCancelReason: string;
  otherCancelReason: string;
  modifiedBy: string;
  modifiedOn: string;
  action: string;
  portal: string;
}

export interface ConsultOnHold {
  onHoldReason: string;
  onHoldSubReason: string;
  onHoldOtherReason: string;
  modifiedBy: string;
  modifiedOn: string;
  action: string;
  portal: string;
}

export interface ConsultOtherActions {
  modifiedBy: string;
  modifiedOn: string;
  action: string;
  portal: string;
}

export type HttpRequestFn = <T>(config: HttpRequestConfig) => Promise<T>;

export const consultHistoryService = (httpRequest: HttpRequestFn) => ({
  getConsultHistory: async (consultId: number, portalType: string) => {
    const response = await httpRequest<ConsultHistoryProps>({
      url: `/integration/${consultId}/history`,
      method: 'GET',
      apiBaseType: 'INTEGRATION',
      headers: {
        portalType: portalType,
      },
    });
    return response;
  },
});
